import { InviteSendParams } from "@common/actions/invites";
import { QuestionnaireListDto } from "@common/dto/questionnaire/list-dto";

export enum PatientInviteStep {
  questionnaires = 'questionnaires',
  receiverChooser = 'receiverChooser',
  patientDetails = 'patientDetails',
  patientAdditionalDetails = 'patientAdditionalDetails',
  individualMoveToPedigree = 'individualMoveToPedigree',
  individualChooser = 'individualChooser',
  pedigreeChooser = 'pedigreeChooser',
  emailTemplate = 'emailTemplate',
  queryChooser = 'queryChooser',
  queryFormatManagement = 'queryManagement',
}

export type PatientInviteStepConfig = {
  previousStep?: PatientInviteStep;
  component: React.ReactNode;
  submitBtnProps?: {
    text?: string;
    disabled?: boolean;
  };
  submitting?: boolean;
  onGoToPreviousStep?: () => void;
  onSubmit: () => Promise<void> | void;
};

export interface IPatientInviteFlow {
  stepsConfig: Partial<Record<PatientInviteStep, PatientInviteStepConfig>>;
  getFirstStep: () => PatientInviteStep;
}

export type PatientInviteFlowProps = {
  onSubmit: (params: InviteSendParams) => Promise<void>;
  setCurrentStep: (step: PatientInviteStep) => void;
  showErrorMessage: (message: string) => void;
  questionnaire?: QuestionnaireListDto;
};